import React, { useContext,  useEffect, useRef } from "react";
import "../../App.css";
import { DashBoardLayout } from "../Dashboard/Layout/DashBoardLayout";
import ProfileHero from "./ProfileHero";
import ProfileUpdate from "./My Profile Page/ProfileUpdate";
import { ContextProvider } from "../Context";
import AccountVerficationPage from "./Account Verification/AccountVerficationPage";
import BusinessKYC from "./My Profile Page/BusinessKYC";
import ChangePin from "./My Profile Page/ChangePin";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { GetLocalStorage } from "../LocalStorage/LocalStorage";
import {  GetFunction } from "../ApiCollection.jsx/ApiBuck";

export default function ProfileSettingsMain(Data) {
  const { profilePage, setProfilePage } = useContext(ContextProvider);
  const { verificationOpen, setVerificationOpen } = useContext(ContextProvider);
  const { setBusinessPopUp } = useContext(ContextProvider);
  const { authenticationOpen, setAuthenticationOpen, setNetworkIssue,  setSessionModal,
          sessionModal
     
   } =
    useContext(ContextProvider);
  const { bvnVerificationOpen, setBvnVerificationOpen } =
    useContext(ContextProvider);
  const { accountUpgrade, setAccountUpgrade } = useContext(ContextProvider);
const { idVerificationOpen, setIdVerificationOpen, networkIssue } =
    useContext(ContextProvider);
    const {setVerificationReason} = useContext(ContextProvider);
    const {setVerificationResponse} = useContext(ContextProvider);

  const location = useLocation();

  const { isDarkMode } = useContext(ContextProvider);

  useEffect(() => {
    if ((location.state &&location.state.verificationOpen) || verificationOpen === true) {
      setProfilePage(false);
      setIdVerificationOpen(true);
      setVerificationOpen(true);
      setAuthenticationOpen(false);
      setBvnVerificationOpen(false);
      setAccountUpgrade(false);
    } else {
       setProfilePage(true);
      setIdVerificationOpen(false);
      setVerificationOpen(false);
      setAuthenticationOpen(false);
      setBvnVerificationOpen(false);
      setAccountUpgrade(false);
      // Set default state here if the verificationOpen state is not passed
    }
  }, [
    location.state,
    setProfilePage,
    setIdVerificationOpen,
    setVerificationOpen,
    setAuthenticationOpen,
    setBvnVerificationOpen,
    setAccountUpgrade,
  ]);


  const QuickCheckVerification = async()=> {
     
    if(!navigator.onLine) {
     setVerificationReason(`${idVerificationOpen === true ? "Nin" : bvnVerificationOpen === true ? "Bvn" : "Nin"} retrieval failed: internet connection error`)
        if(networkIssue) return;
             if(!networkIssue) return setNetworkIssue(true)
             }
    const path ="check-verification";
    const SuccessHandler = (response)=> {
      setVerificationResponse(response)
    }
    const FailedHandler = async(ErrorType, response)=> {
      
      if(ErrorType === "User error" || ErrorType === "Network error"){
             if(networkIssue) return;
             if(!networkIssue) return setNetworkIssue(true)
        setVerificationReason(`${idVerificationOpen === true ? "Nin" : bvnVerificationOpen === true ? "Bvn" : "Nin"} retrieval failed due to unstable connection`)
      }else if(ErrorType === "Bad request"){
        setVerificationResponse(response)
      }else if(ErrorType === "Server error"){
        setVerificationReason(`${idVerificationOpen === true ? "Nin" : bvnVerificationOpen === true ? "Bvn" : "Nin"} retrieval failed try some other time`)
      }else if(ErrorType === undefined){
      setVerificationReason(`${idVerificationOpen === true ? "Nin" : bvnVerificationOpen === true ? "Bvn" : "Nin"} retrieval failed: internet connection error`)
      }else if(ErrorType === "unauthorised"){
       if(sessionModal) return;
       if(!sessionModal) return setSessionModal(true)
      }else {
     
        setVerificationReason(`${idVerificationOpen === true ? "Nin" : bvnVerificationOpen === true ? "Bvn" : ""} retrieval failed.`);
 
      }
    }
  
    const setLoading=(Value)=> {} 
    await GetFunction(path, 
      setLoading, 
      SuccessHandler,
       FailedHandler,
      setVerificationResponse,
    setNetworkIssue)
  }
  // UseEffect to get Users Data
  const ValueRef = useRef();

  Data = GetLocalStorage();
  useEffect(() => {
    ValueRef.current = Data;
    if(Data?.ConfirmId === "true"  || Data?.ConfirmBvn === "true"){
    QuickCheckVerification();
    }
    //eslint-disable-next-line
  }, [idVerificationOpen,bvnVerificationOpen]);
  window.addEventListener("online", ()=> {
       if(Data?.ConfirmId === "true"  || Data?.ConfirmBvn === "true"){
    QuickCheckVerification();
    }
  })

  return (
    <DashBoardLayout>
      <div className="">
        <div className="">
          <ProfileHero />
          <div
            className={`flex flex-wrap md:flex-nowrap 
               mt-[23px] md:w-[100%] md:gap-[53.4px] 
               lg:gap-[91px]  md:border-b-[2px] md:border-[#D9D9D999] 
               border-opacity-[60%] justify-between `}
          >
            {/* Profile Tab */}
            <div
              onClick={() => {
                setProfilePage(true);
                setBvnVerificationOpen(false);
                setIdVerificationOpen(false);
                setAccountUpgrade(false);
                setVerificationOpen(false);
                setAuthenticationOpen(false);
              }}
              className={`flex flex-col md:w-1/4 w-[50%]  
                lg:gap-[23px] cursor-pointer md:border-none 
                border-b-[1.7px] border-[#D9D9D999] border-opacity-[60%] 
                ${isDarkMode ? "border-white" : ""}`}
            >
              <h2
                className={`font-[600] text-[#A3A3A3] py-[8px]
                   text-start pl-[10px] text-[12px] lg:p-[10px] 
                   leading-[14px] lg:text-[16px] lg:leading-[24px] ${
           isDarkMode ? "text-stone-50" : ""
         }`}
              >
                My Profile
              </h2>
              {/* Profile Cursor */}
              {profilePage && (
                <div
                  className={`flex w-[100%] md:w-[60%] md:h-[3px] h-[2px] rounded-[10px]  bg-[#04177F] ${isDarkMode ? "bg-white": ""}`}
                ></div>
              )}
            </div>
            {/* ACCOUNT VERIFICATION TAB */}
            <div
              onClick={() => {
                setProfilePage(false);
                setIdVerificationOpen(true);
                setVerificationOpen(true);
                setAuthenticationOpen(false);
              }}
              className="flex flex-col md:w-1/4 w-[50%]  lg:gap-[23px] cursor-pointer 
                    md:border-none border-b-[1.7px] border-[#D9D9D999] border-opacity-[60%]"
            >
              <h2
                className={`font-[600] text-[#A3A3A3] text-center md:text-start
                    text-[12px] lg:p-[10px] py-[8px]
                  leading-[14px] lg:text-[16px] lg:leading-[24px]  cursor-pointer ${
                    isDarkMode ? "text-stone-50" : ""
                  }`}
              >
                Account Verification
              </h2>
              {/* VERIFICATION CURSOR */}
              {verificationOpen && (
                <div className={`flex w-[100%] md:w-[60%] md:h-[3px] h-[2px] rounded-[10px]  bg-[#04177F] ${isDarkMode ? "bg-white": ""}`}></div>
              )}
            </div>
            <div
              onClick={() => {
                setBusinessPopUp(true);
              }}
              className="md:w-1/4 w-[50%] md:pt-[0px] pt-[30px] lg:gap-[23px] cursor-pointer
                    md:border-none border-b-[1.7px] border-[#D9D9D999] border-opacity-[60%]"
            >
              {/* BUSINESS KYC TAB */}
              <h2
                className={`lg:p-[10px] font-semibold text-[#A3A3A3] 
                     text-[12px] leading-[14px] py-[8px] text-start pl-[10px]
                    lg:text-[16px] lg:leading-[24px]  cursor-pointer ${
                      isDarkMode ? "text-stone-50" : ""
                    }`}
              >
                Business KYC / KYB
              </h2>
            </div>
            <div
              onClick={() => {
                setAuthenticationOpen(true);
                setVerificationOpen(false);
                setProfilePage(false);
                setBvnVerificationOpen(false);
                setIdVerificationOpen(false);
                setAccountUpgrade(false);
              }}
              className={`md:w-1/4 w-[50%] flex flex-col md:pt-[0px] pt-[30px] lg:gap-[23px] cursor-pointer
                    md:border-none border-b-[1.7px] border-[#D9D9D999] border-opacity-[60%] ${isDarkMode ? "border-white" : ""}`}
            >
              {/* AUTHETICATION TAB */}
              <h2
                className={`lg:p-[10px] font-[600] text-[#A3A3A3] 
                    text-[12px] leading-[14px] md:text-start text-center py-[8px]
                    lg:text-[16px] lg:leading-[24px]  cursor-pointer ${
                      isDarkMode ? "text-stone-50" : ""
                    }`}
              >
                Authentication Settings
              </h2>
              {/* AUTHENTICATION CURSOR */}
              {authenticationOpen && (
                <div
                  className={`flex w-[100%] md:w-[60%] md:h-[3px] h-[2px] rounded-[10px]  bg-[#04177F] ${isDarkMode ? "bg-white": ""}`}
                ></div>
              )}
            </div>
          </div>

          <ProfileUpdate
            fullname={Data.UserFullName}
            Email={Data.UserEmail}
            Phone={Data.UserPhone}
            Username={Data.aremxyUsername}
          />
          <AccountVerficationPage />
          <BusinessKYC />
          <ChangePin />
        </div>
        <div
          className={` flex gap-[8.729px] pt-[30%] pb-[20%] lg:pt-[20%] lg:pb-[10%] md:pt-[120%] md:pb-[50px] md:gap-[14.896px] justify-center px-[8.594px]
     ${profilePage ? "md:pt-[140%] md:pb-[50px]" : ""}
     ${idVerificationOpen ? "md:pt-[120%] md:pb-[50px]" : ""}
     ${bvnVerificationOpen ? "md:pt-[135%] md:pb-[50px]" : ""}
     ${accountUpgrade ? "md:pt-[50%] md:pb-[50px]" : ""}
     ${authenticationOpen ? "md:pt-[135%] md:pb-[50px] " : ""} `}
        >
          <p
            className={`font-[500] text-[10px] text-black 
              leading-[10.4px] lg:text-[16px] lg:leading-[15.6px]  md:text-[6.875px] md:leading-[12.938px] self-center ${isDarkMode ? "text-white" : ""}`}
          >
            You need help?
          </p>
          <Link
            to="/contactUs"
            className="font-[500] text-white text-xs  py-[4.865px] px-[10.594px] rounded-[5.156px] bg-[#04177F] lg:text-[12px] lg:leading-[14.4px] md:text-[4.583px]  md:py-[4.865px] md:px-[14.594px] md:leading-[5.985px]  lg:py-[10px] lg:px-[16px] lg:rounded-[9px]"
          >
            Contact Us
          </Link>
        </div>
      </div>
   
    </DashBoardLayout>
  );
}
